import React from "react";

import classnames from "classnames";
import HighchartsReact from "highcharts-react-official";

import Highcharts from "@lib/highcharts";

import { HighchartsWrapper as StyledContainer } from "./HighchartsWrapper.style";
import type { HighchartsWrapperContentProps } from "./types";
import { useOperatorChartData } from "./utils/useOperatorChartData";

export const HighchartsWrapperContent = ({
  className,
  chartConfig,
  allowChartUpdate,
  immutable,
  operatorChartData,
  operatorId,
}: HighchartsWrapperContentProps): React.ReactElement => {
  const operatorDataAccess = useOperatorChartData(operatorChartData, operatorId);

  return (
    <StyledContainer
      id={operatorId}
      className={classnames("db-highcharts-wrapper", className)}
      data-operator-description={operatorDataAccess?.description}
    >
      <HighchartsReact
        allowChartUpdate={allowChartUpdate}
        highcharts={Highcharts}
        options={chartConfig}
        immutable={immutable}
      />
    </StyledContainer>
  );
};
